import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useSportContent } from '../hooks/useSportContent';

const DrillsScreen: React.FC = () => {
  const { currentSport } = useTheme();
  const { content, loading, error } = useSportContent(currentSport.id);

  if (loading) {
    return (
      <div className="drills-screen">
        <div className="container">
          <h1>Loading {currentSport.name} Drills...</h1>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="drills-screen">
        <div className="container">
          <h1>Error Loading Drills</h1>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="drills-screen">
      <div className="container">
        <h1>{currentSport.name} Drills</h1>
        <div className="drills-grid">
          {content?.drills.map((drill) => (
            <div key={drill.id} className="drill-card">
              <h3>{drill.title}</h3>
              <p>{drill.description}</p>
              <div className="drill-meta">
                <span className="difficulty">{drill.difficulty}</span>
                <span className="duration">{drill.duration} min</span>
              </div>
              <div className="equipment">
                <strong>Equipment:</strong> {drill.equipment.join(', ')}
              </div>
              <div className="instructions">
                <strong>Instructions:</strong>
                <ol>
                  {drill.instructions.map((instruction, index) => (
                    <li key={index}>{instruction}</li>
                  ))}
                </ol>
              </div>
              <div className="tips">
                <strong>Tips:</strong>
                <ul>
                  {drill.tips.map((tip, index) => (
                    <li key={index}>{tip}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DrillsScreen;
